var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "navbar" }, [
    _c(
      "div",
      { staticClass: "navbar-brand brand-small" },
      [
        _c(
          _vm.isStaff ? "router-link" : "a",
          _vm._b(
            { tag: "component" },
            "component",
            _vm.isStaff ? { to: { name: "dashboard" } } : { href: _vm.urlHome },
            false
          ),
          [
            _c("SaasIcon", {
              staticClass: "navbar__logo",
              attrs: {
                icon: _vm.logoIcon,
                width: _vm.logoWidth,
                height: _vm.logoHeight
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "navbar-container" },
      [
        _vm._t("search"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "navbar-content" },
          [
            _vm.showEInvoicingConformityCheckList
              ? _c("ConformityCheckListHeader")
              : _vm._e(),
            _vm._v(" "),
            _vm._t("onboarding-screen"),
            _vm._v(" "),
            _c("NavMenu", {
              attrs: {
                menuItems: _vm.menuData.items,
                hasNotification: _vm.menuData.hasNotification
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "navbar__divider" }),
            _vm._v(" "),
            _c("NavProfilMenu", {
              attrs: {
                userData: _vm.userData,
                urlsData: _vm.urlsData,
                lang: _vm.lang
              }
            })
          ],
          2
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }